import { NotificationStore } from './notification-store';
import { Provider } from '@angular/core';
import { Environment } from '../environment';

export * from './model';
export * from './service';
export * from './notification-store';
export const provideNotification = (environment: Environment): Provider[] => [NotificationStore];
